import type { IconProps } from "./types-icon";
import { useIcon } from "./use-icon";
import { IconView } from "./view-icon";

/** SVG inline do Figma pintado por `currentColor`; a forma e a acessibilidade vêm do `useIcon`. */
export function Icon(props: IconProps) {
  const viewModel = useIcon(props);

  return <IconView {...viewModel} />;
}
Icon.displayName = "Icon";
